import { authSlice } from "../reducers/authReducer";


const authActions = authSlice.actions;

export default authActions;